function returnOptions(data) {
  // 定义时间
  const timeList = data.map((item) => item.dateTime);
  // 会员消费人数
  const memberCountList = data.map((item) => item.memberCount);
  // 散客消费人数
  const noMemberCountList = data.map((item) => item.noMemberCount);
  // 环比增长率（%）
  const chainGrowthList = data.map((item) => item.chainGrowth);
  return {
    color: ['#fe6d6c', ' #ffdbdb', '#20a0ff'],
    legend: {
      right: '15%',
      data: ['会员消费人数', '散客消费人数', '环比增长率（%）'],
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      },
      formatter(param) {
        const num = param[0].data + param[1].data;
        return `总客流（人）：${num}<br/>会员消费人数：${param[0].data}<br/>散客消费人数：${param[1].data}<br />环比增长率：${param[2].data}%`;
      }
    },
    grid: {
      right: '20%'
    },
    xAxis: {
      type: 'category',
      data: timeList,
      axisPointer: {
        type: 'shadow'
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '会员消费人数',
        axisLabel: {
          formatter: '{value} '
        },
        splitLine: {
          show: false
        }
      },
      {
        type: 'value',
        name: '环比增长率（%）',
        min: Math.min.apply(null, chainGrowthList),
        max: Math.max.apply(null, chainGrowthList),
        axisLabel: {
          formatter: '{value}%'
        },
        splitLine: {
          show: false
        }
      }
    ],
    series: [{
      name: '会员消费人数',
      type: 'bar',
      data: memberCountList
    },
    {
      name: '散客消费人数',
      type: 'bar',
      data: noMemberCountList
    },
    {
      name: '环比增长率（%）',
      type: 'line',
      data: chainGrowthList
    },
    ]
  };
}
export const echartsA = returnOptions;
